<div class="left-side">
  <div class="left-side__workspace-selector">
    <div
      class="left-side__workspace-selector__overlay"
      (click)="workspaceSelectorOverlayBox.displayOverlay($event.target)"
    ></div>
    <ts-avatar-group
      [roundedCorners]="true"
      [avatars]="[
        {
          imageSrc: (account$ | async)?.image_url,
          name: (account$ | async)?.name,
        },
      ]"
    />
    <p class="left-side__workspace-selector__name">
      {{ (account$ | async)?.name }}
      @if (environment !== 'production') {
        <ts-badge [value]="environment" type="info"></ts-badge>
      }
    </p>
    <ts-icon icon="keyboard_arrow_down" class="left-side__workspace-selector__icon" />
  </div>
</div>
<div class="center-side">
  <ts-input
    icon="ts_search"
    [placeholder]="searchPlaceholder"
    size="sm"
    (click)="openSearchModal()"
    [readonly]="true"
    [formControl]="searchControl"
  />
</div>
<div class="right-side">
  <notifications />
  <celeste-toggle [account]="account$ | async" />
  <ts-button type="icon" icon="megaphone" iconCssClass="rnw-badge" iconColor="black" lucideIcon="true"></ts-button>
  <ts-avatar-group
    [avatars]="[
      {
        imageSrc: (user$ | async)?.avatar_url,
        name: (user$ | async)?.full_name,
      },
    ]"
    (click)="profileOverlayBox.displayOverlay($event.target)"
  />
</div>

<ts-overlay #profileOverlayBox [position]="'bottom'" [transparentBackdrop]="true" cssClass="ts-overlay-acc-profile">
  <div class="side-panel user-menu">
    <div class="side-panel__header">
      <div class="side-panel__header__top">
        <div class="side-panel__header__top__text user">
          <ts-avatar-group
            [avatars]="[
              {
                imageSrc: (user$ | async)?.avatar_url,
                name: (user$ | async)?.full_name,
              },
            ]"
            [badge]="(user$ | async)?.roles?.[0]?.label"
            size="big"
          />
          <div class="side-panel__header__top__text__user-info">
            <p class="side-panel__header__top__text__user-info__name">
              {{ (user$ | async)?.full_name }}
            </p>
            <p class="side-panel__header__top__text__user-info__email">{{ (user$ | async)?.email }}</p>
          </div>
        </div>
      </div>
    </div>
    <ts-divider spacing="none"></ts-divider>
    <div class="side-panel__items">
      <div class="side-panel__items__item" [routerLink]="['/profile']">
        <lucide-icon name="user" size="16"></lucide-icon>
        <div class="side-panel__items__item__name">
          <p>Profile</p>
        </div>
      </div>
      <div class="side-panel__items__item" (click)="toggleStyleOptions()">
        <lucide-icon name="palette" size="16"></lucide-icon>
        <div class="side-panel__items__item__name">
          <p>Style Settings</p>
          @if (!styleOptionsOpen()) {
            <ts-icon icon="keyboard_arrow_down" class="side-panel__items__item__icon"></ts-icon>
          } @else {
            <ts-icon icon="keyboard_arrow_up" class="side-panel__items__item__icon"></ts-icon>
          }
        </div>
      </div>
      @if (styleOptionsOpen()) {
        <div class="side-panel__items__style-options animate__animated animate__fadeIn animate__faster">
          <div
            class="side-panel__items__style-options__item"
            [ngClass]="{ 'style-selected': (styleSettings$ | async) === 'compact' }"
            (click)="setFontSize('compact')"
          >
            <span [class.invisible]="(styleSettings$ | async) !== 'compact'">
              <ts-icon icon="check"></ts-icon>
            </span>
            Compact
          </div>
          <div
            class="side-panel__items__style-options__item"
            [ngClass]="{ 'style-selected': (styleSettings$ | async) === 'small' }"
            (click)="setFontSize('small')"
          >
            <span [class.invisible]="(styleSettings$ | async) !== 'small'">
              <ts-icon icon="check"></ts-icon>
            </span>
            Small
          </div>
          <div
            class="side-panel__items__style-options__item"
            [ngClass]="{
              'style-selected': (styleSettings$ | async) === 'normal' || (styleSettings$ | async) === null,
            }"
            (click)="setFontSize('normal')"
          >
            <span [class.invisible]="(styleSettings$ | async) !== null && (styleSettings$ | async) !== 'normal'">
              <ts-icon icon="check"></ts-icon>
            </span>
            Normal
          </div>
        </div>
      }
    </div>
    <ts-divider spacing="none"></ts-divider>
    <div class="side-panel__footer">
      <div class="side-panel__footer__item">
        <lucide-icon name="log-out" size="16"></lucide-icon>
        <p class="side-panel__footer__text cursor-pointer" [routerLink]="['/sign-out']">Sign out</p>
      </div>
    </div>
  </div>
</ts-overlay>

<ts-overlay
  #workspaceSelectorOverlayBox
  [position]="{
    offsetX: 0,
    offsetY: 0,
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }"
  [transparentBackdrop]="true"
  cssClass="ts-overlay-acc-profile"
>
  <div class="side-panel">
    <div class="side-panel__header">
      <div class="side-panel__header__top">
        <ts-avatar-group
          [roundedCorners]="true"
          [avatars]="[
            {
              imageSrc: (account$ | async)?.image_url,
              name: (account$ | async)?.name,
            },
          ]"
        />
        <p class="side-panel__header__top__text">{{ (account$ | async)?.name }}</p>
        <ts-badge [value]="environment" type="info"></ts-badge>
      </div>
      <div class="side-panel__header__actions">
        <ts-button type="stroked" color="accent" icon="settings" lucideIcon="true" (buttonClick)="openSettings()"
          >Settings</ts-button
        >
        <ts-button type="stroked" color="accent" icon="users" lucideIcon="true" (buttonClick)="openPeople()"
          >People</ts-button
        >
      </div>
    </div>
    <ts-divider spacing="none"></ts-divider>
    <div class="side-panel__items"></div>
    <ts-divider spacing="none"></ts-divider>
    <div class="side-panel__footer">
      <div class="side-panel__footer__item">
        <lucide-icon name="arrow-right-left" size="16"></lucide-icon>
        <p class="side-panel__footer__text cursor-pointer" [routerLink]="['/accounts']">Switch Workspace</p>
      </div>
      @if (isTermSheetUser$ | async) {
        <div class="side-panel__footer__item" (click)="openCreateWorkspaceDialog()">
          <lucide-icon name="plus" size="16"></lucide-icon>
          <p class="side-panel__footer__text cursor-pointer">Create New Workspace</p>
        </div>
      }
    </div>
  </div>
</ts-overlay>
